export const CountriesService = {
	async get3LetterCountry(country: string) {
		const countries = await import('i18n-iso-countries');
		// HOTFIX: error when building on the server, say string/undefined is not assignable to string
		return countries.alpha2ToAlpha3(country) ?? '';
	},
};
